import {JobStatusDetailsBadge, IFleetPartnerCourierListingOutput, IPackageSizesOutput} from 'palipali-panel-common-web';
import {Box} from '@mui/material';
import React from 'react';
import StatusBadge from '../../../../../Couriers/StatusBadge';

interface IDeliveryStatusInfoProps {
    courier: IFleetPartnerCourierListingOutput;
}

type IPackageSize = 's' | 'm' | 'l';

const DeliveryStatusInfo: React.FC<IDeliveryStatusInfoProps> = ({courier}) => {
    const getPackageSizes = () => {
        const availableSizesObj: IPackageSizesOutput | null = courier.activePackageSizes;
        const activeSize: IPackageSize | undefined = courier.currentJob?.packageSize;

        if (!availableSizesObj) return;
        const sizes: IPackageSize[] = ['s', 'm', 'l'];
        const availableSizes = sizes.filter((size: IPackageSize) => availableSizesObj[size] === true);

        return availableSizes.map((size: string) => {
            const sizeClass = size === 's' ? 'small' : size === 'm' ? 'medium' : 'large';
            const activeClass = size === activeSize ? ' active' : '';
            return (
                <span key={`item_${size}`} className={`package-size-icon ${sizeClass}${activeClass}`}>
                    {size}
                </span>
            );
        });
    };

    const getStatusBadge = () => {
        if (!courier.status) return;
        if (!courier.currentJob) return <StatusBadge status={'online'} />;

        return <JobStatusDetailsBadge status={courier.currentJob.deliveryStatus} />;
    };

    return (
        <>
            {getStatusBadge()}
            <Box className="active-courier-package-sizes">{getPackageSizes()}</Box>
        </>
    );
};

export default DeliveryStatusInfo;
